module.exports = __webpack_public_path__ + "img/rang2.03701915.png";